// React & Libraries
import { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Edit } from "react-feather";
import { Btn, H3, P } from "../../../../../../AbstractElements";

// Forms
import UpdateIndustryForm from "./UpdateIndustryForm";

interface UpdateNationalityModalProps {
  id: number;
}
const UpdateIndustryModal = ({ id }: UpdateNationalityModalProps) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        size="sm"
        color="primary"
        className="px-2"
        onClick={toggle}
        style={{ width: "105px" }}
      >
        {" "}
        <Edit size={11} /> Update
      </Btn>

      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Industry Record</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Update the industry record to keep employee and applicant personal
              information accurate and up to date.
            </P>
          </ModalHeader>

          <UpdateIndustryForm toggle={toggle} id={id} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateIndustryModal;
